import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import type { UserInfo } from '@/features/register/context/register.context';

import { useInterviewContext } from '@/features/common/contexts/interview.context';
import FormScreen from '@/features/register/pages/FormScreen';

import { useRegisterContext } from '../../contexts/register-context.ref';

export default function RegisterNamesPage() {
  const navigate = useNavigate();
  const { onReset } = useInterviewContext();
  const { registerInitialData, setRegisterInitialData } = useRegisterContext();

  const handleNext = useCallback(
    (partial?: Partial<UserInfo>) => {
      if (partial) setRegisterInitialData(prev => ({ ...prev, ...partial }));
      navigate('/register/city', { replace: true });
    },
    [navigate, setRegisterInitialData],
  );

  const handleBack = useCallback(() => {
    navigate('/register/cgu', { replace: true });
  }, [navigate]);

  return (
    <FormScreen
      step="names"
      onNext={handleNext}
      onCancel={onReset}
      onBack={handleBack}
      initialData={registerInitialData}
    />
  );
}
